<template>
  <div :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''">
    <v-content class="pa-4">
      <iframe src="http://172.20.4.13:9901/#/dashboard" width="100%" height="700px"></iframe>
    </v-content>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
  },
}
</script>

<style scoped>
</style>